import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const PrivacyModal = ({ show, onAccept, onRefuse, readOnly = false }) => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (show) {
      const lang = i18n.language || 'fr';
      fetch(`/privacy_${lang}.md`)
        .then((response) => {
          if (!response.ok) throw new Error("Fichier introuvable");
          return response.text();
        })
        .then((text) => setContent(text))
        .catch(() => {
          fetch(`/privacy_en.md`)
            .then((res) => res.text())
            .then((text) => setContent(text))
            .catch((err) => setContent("Erreur de chargement de la politique de confidentialité."));
        });
    }
  }, [show, i18n.language]);
  
  return (
    <Modal show={show} onHide={onRefuse} backdrop={readOnly ? true : "static"} keyboard={readOnly} size="lg" centered>
      <Modal.Header closeButton={readOnly}>
        <Modal.Title>{t('privacy.title', 'Politique de Confidentialité')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto', textAlign: 'left' }}>
        <div className="text-start markdown-body">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {readOnly ? (
          <Button variant="secondary" onClick={onRefuse}>
            {t('common.close', 'Fermer')}
          </Button>
        ) : (
          <>
            <Button variant="secondary" onClick={onRefuse}>
              {t('common.refuse', 'Refuser')}
            </Button>
            <Button variant="primary" onClick={onAccept}>
              {t('common.accept', 'Accepter')}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PrivacyModal;
